export enum IntermediaryTypes {
    TRAVEL_AGENCY = "TRAVEL_AGENCY",
    INSURANCE_BROKER = "INSURANCE_BROKER",
    FINANCIAL_ADVISOR= "FINANCIAL_ADVISOR",
    INDEPENDENT_FINANCIAL_ADVISOR = "INDEPENDENT_FINANCIAL_ADVISOR"

}

